var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationAlert = function SvgNotificationAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.084 4.25a.473.473 0 0 1 .834 0l8.028 15.059a.47.47 0 0 1-.417.691H4.473a.47.47 0 0 1-.417-.691zm.417 1.223L5.258 19.059h14.485L12.5 5.473zM13 16.5v1h-1v-1h1zm0-7v6h-1v-6h1z",
    fill: "#FFB600",
    fillRule: "nonzero"
  })));
};
export default SvgNotificationAlert;